import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: "/",
        name: "Home",
        redirect: "/home",
    },
    {
        path: "/home",
        name: "Home",
        component: () =>
            import ('../views/Home')
    },
    {
        path: "/login",
        name: "Login",
        component: () =>
            import ('../views/Login')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach(async(to, from, next) => {
    if (to.path === "/") {
        next("/home")
        return;
    }
    const requiresAuth = to
        .matched
        .some(record => record.meta.requiresAuth)
    if (requiresAuth) {
        console.log('CheckSession!');
        next();
        return;
    }
    next();
})
export default router